import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { Widget, WidgetPositioning } from "@src/types/dashboards";

export interface PutUpdateWidgetV2Result {
  success: boolean;
  data?: Widget;
  error?: string;
}

/** Send the same body shape the POST endpoint now takes. `widget` MUST
 *  have `id` stripped — the id is in the URL instead. Returns the
 *  updated widget. */
export const putUpdateWidgetV2UseCase = async (
  dashboardId: string,
  widgetId: string,
  widget: Omit<Widget, "id">,
  positioning: WidgetPositioning,
  imageFile?: File | null,
): Promise<PutUpdateWidgetV2Result> => {
  try {
    const authContext = store.getState().yourSlice.authContext;
    if (!authContext) {
      return { success: false, error: "Not authenticated" };
    }
    const response = await apiUseCases.putUpdateWidgetV2(
      authContext.customerNamespace,
      dashboardId,
      widgetId,
      widget,
      positioning,
      imageFile,
    );

    return { success: true, data: response.data };
  } catch (error) {
    const parsed = parseAxiosApiError(error, "Failed to update widget");
    return { success: false, error: parsed.message };
  }
};
